import { render, staticRenderFns } from "./supplydemandinfo.vue?vue&type=template&id=f1f01b08&scoped=true&"
import script from "./supplydemandinfo.vue?vue&type=script&lang=js&"
export * from "./supplydemandinfo.vue?vue&type=script&lang=js&"
import style0 from "./supplydemandinfo.vue?vue&type=style&index=0&id=f1f01b08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f01b08",
  null
  
)

export default component.exports